var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autocomplete',_vm._g(_vm._b({attrs:{"item-value":"id","item-text":"nome","items":_vm.categorie,"loading":_vm.loading,"value":_vm.value}},'autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }